export const FR = {
    translations: {
        notifications: 'Notifications',
        markAllAsRead: 'Tout marquer comme lus',
        poweredBy: 'Propulsé par',
        settings: 'Paramètres',
        noNewNotification: 'Rien de nouveau à voir ici pour le moment',
    },
    lang: 'fr',
};
//# sourceMappingURL=fr.js.map